import BasketItemCard from './BasketItemCard';
import BasketItemOrdersUnionDetails from '../Components/BasketItemOrdersUnionDetails';
import useBasketItemHelpers from "../hooks/useBasketItemHelpers";

const BasketItemOrdersUnion = (props) => {
    const { handleChange, getImageUrl } = useBasketItemHelpers({
        props,
    });

    return (
        <BasketItemCard
            imageUrl={getImageUrl()}
            imageAlt={props.item.bookName}
            showCheckbox={props.isDeletionMode}
            isChecked={props.isChecked}
            onToggle={handleChange}
            quantity={props.item.quantity}
            item={props.item}
        >
            <BasketItemOrdersUnionDetails
                quantity={props.item.quantity}
                format={props.item.format}
                cover={props.item.cover}
                pagesNumber={props.item.pagesNumber}
                bookName={props.item.bookName}
                imageUrl={getImageUrl()}
            />
        </BasketItemCard>
    )
}
export default BasketItemOrdersUnion;
